import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form-floating mb-3" };
const _hoisted_2 = ["min", "step"];
const _hoisted_3 = { for: "productsAmount" };
const _hoisted_4 = { class: "fs-6" };
const _hoisted_5 = { class: "fs-4 fw-bold" };
import { formatters } from '@/Composables/formatters';
import axios from 'axios';
import { debounce } from 'lodash';
import { onMounted, ref, watch } from 'vue';
import ConfigurationPriceComposition from './ConfigurationPriceComposition.vue';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigurationPriceCalculator',
    props: {
        configurationId: String,
        tenantId: {
            type: String,
            default: ''
        },
        minProductsAmount: {
            type: Number,
            default: 1
        },
        maxProductsAmount: {
            type: Number,
            default: 1
        },
        productsAmountSteps: {
            type: Number,
            default: 1
        }
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        let { formatCurrency } = formatters();
        const props = __props;
        const emit = __emit;
        const key = ref('');
        const productsAmount = ref(1000);
        const totalPrice = ref(0);
        const singlePrice = ref(0);
        onMounted(() => {
            calculateTotalPrice();
            calculateSinglePrice();
            setInterval(() => {
                calculateTotalPrice();
                calculateSinglePrice();
            }, 5000);
        });
        const debouncedCalculate = debounce(() => {
            if (productsAmount.value && !isNaN(productsAmount.value)) {
                if (productsAmount.value < props.minProductsAmount) {
                    productsAmount.value = props.minProductsAmount;
                }
                if (productsAmount.value > props.maxProductsAmount) {
                    productsAmount.value = props.maxProductsAmount;
                    Swal.fire({
                        title: t('Höhere Stückzahl? - Kein Problem!'),
                        html: trans('Bitte kontaktieren Sie uns bei mehr als {maxProductsAmount} gewünschten Produkten.<br />Wir erstellen gerne ein individuelles Angebot für Sie.', { maxProductsAmount: props.maxProductsAmount }),
                        icon: 'info',
                        confirmButtonText: t('Ok'),
                        confirmButtonColor: "#528399",
                        timer: 10000
                    });
                }
                if (props.productsAmountSteps > 1) {
                    productsAmount.value = Math.round(productsAmount.value / props.productsAmountSteps) * props.productsAmountSteps;
                }
                calculateTotalPrice();
                calculateSinglePrice();
                emit('update', productsAmount.value);
            }
            else {
                totalPrice.value = 0;
            }
        }, 500);
        watch(productsAmount, () => {
            debouncedCalculate();
        });
        function calculateTotalPrice() {
            axios.post(route('configurator.priceCalculation.getTotalPrice', props.configurationId), {
                amount: productsAmount.value
            })
                .then(function (response) {
                totalPrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function calculateSinglePrice() {
            axios.post(route('configurator.priceCalculation.getSinglePrice', props.configurationId), {
                amount: productsAmount.value
            })
                .then(function (response) {
                singlePrice.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showPriceOverview() {
            key.value = Math.random().toString(36).substring(7);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "productsAmount",
                            placeholder: "Gewünschte Anzahl",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((productsAmount).value = $event)),
                            min: props.minProductsAmount,
                            step: props.productsAmountSteps,
                            max: "10000"
                        }, null, 8, _hoisted_2), [
                            [_vModelText, productsAmount.value]
                        ]),
                        _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(t)('Gewünschte Anzahl')), 1)
                    ]),
                    _createElementVNode("div", {
                        class: "bg-light rounded d-flex justify-content-between align-items-center px-3 py-2",
                        style: { "cursor": "pointer" },
                        onClick: showPriceOverview
                    }, [
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('Einzelpreis')), 1),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(singlePrice.value)), 1)
                    ])
                ]),
                (key.value != '')
                    ? (_openBlock(), _createBlock(ConfigurationPriceComposition, {
                        configurationId: props.configurationId,
                        amount: productsAmount.value,
                        key: key.value
                    }, null, 8, ["configurationId", "amount"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
